import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import CarouselIndicators from "./MiniComponents/CarouselIndicators/CarouselIndicators";
import AddMaintenanceScheduleCarousel from "./MiniComponents/AddMaintenanceScheduleCarousel/AddMaintenanceScheduleCarousel";
import StatusMaintenanceItemsCarousel from "./MiniComponents/StatusMaintenanceItemsCarousel/StatusMaintenanceItemsCarousel";
import { createMaintenanceSchedule, getAllMaintenanceScheduleById, updateMaintenanceSchedule, assignTechnician } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import { createBulkMaintenanceItem, getAllMaintenanceItems } from "../../../redux/MaintenanceItemSlice/MaintenanceItemSlice";
import { getAllStandardMaintenanceItems } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import { getAllContracts, getContractById } from "../../../redux/contractSlice/contractSlice";
import { getAllUsers } from "../../../redux/userSlice/userSlice";
import notify from "../../../hooks/useNotifaction";
import { ROLES } from "../../../constants/roles";

export default function AddContract() {
  const { ContractId, ScheduleId } = useParams();
  const { pathname } = useLocation();
  const isAddItemsForSchedilesContractPage = pathname == `/Contracts/${ContractId}/AddStandardMaintenanceItem`;
  const [activeTab, setActivetab] = useState(isAddItemsForSchedilesContractPage ? 1 : 0);
  const dispatch = useDispatch();
  const { allContracts } = useSelector((state) => state.contract);
  const { allUsers } = useSelector((state) => state.user);
  const { specificMaintenanceSchedule } = useSelector((state) => state.maintenanceSchedule);
  const mangerUsers = allUsers && allUsers.length > 0 && allUsers.filter((user) => user.role == ROLES.MANAGER);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getAllContracts());
    dispatch(getAllUsers({ page: 0 }));
  }, []);
  useEffect(() => {
    if (ScheduleId) {
      dispatch(getAllMaintenanceScheduleById(ScheduleId));
    }
  }, [ScheduleId]);
  useEffect(() => {
    if (specificMaintenanceSchedule && ScheduleId) {
      setMaintenanceSchedules(specificMaintenanceSchedule);
    }
  }, [ScheduleId, specificMaintenanceSchedule]);
  const [maintenanceSchedules, setMaintenanceSchedules] = useState({
    maintenance_manager_id: "",
    title: "",
    schedule_date: "",
    start_time: "",
    end_time: "",
    priority: "",
    notes: "",
    contract_id: "",
    has_fire_extinguishers: false,
  });
  useEffect(() => {
    console.log(maintenanceSchedules);
  }, [maintenanceSchedules]);
  const validateForm = () => {
    const errors = {};
    if (!maintenanceSchedules.title.trim()) errors.title = "اسم الجدول مطلوب";
    if (!maintenanceSchedules.schedule_date) errors.schedule_date = "تاريخ الجدول مطلوب";
    if (!maintenanceSchedules.start_time) errors.start_time = "وقت البدء مطلوب";
    if (!maintenanceSchedules.contract_id) errors.contract_id = "يجب اختيار العقد";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Object.values(formErrors).forEach((errorMsg) => {
        notify(errorMsg, "error");
      });
      return;
    }

    try {
      if (!ScheduleId) {
        await dispatch(createMaintenanceSchedule(maintenanceSchedules)).unwrap();
        notify("تم إنشاء الجدول بنجاح", "success");
      } else {
        console.log(maintenanceSchedules)
        await dispatch(updateMaintenanceSchedule({ id: ScheduleId, data: maintenanceSchedules })).unwrap();
        notify("تم تعديل الجدول بنجاح", "success");
      }
      // navigate("/MaintenanceSchedules");
      setMaintenanceSchedules({
        maintenance_manager_id: "",
        title: "",
        schedule_date: "",
        start_time: "",
        end_time: "",
        priority: "",
        notes: "",
        contract_id: "",
      });
    } catch (err) {
      notify(err?.message, "error");
    }
  };

  return (
    <div className="main addContract">
      <h1 className="text-white">اضافة جدول</h1>

      <div className="card mt-5">
        <div id="carouselExampleIndicators" className="carousel slide">
          <CarouselIndicators items={isAddItemsForSchedilesContractPage ? ["building"] : !ScheduleId ? ["city"] : ["city"]} activeIndex={activeTab} />
          <div className="carousel-inner">
            {isAddItemsForSchedilesContractPage ? (
              <div className="carousel-item active">
                <StatusMaintenanceItemsCarousel />
              </div>
            ) : (
              <>
                <div className="carousel-item active">
                  <AddMaintenanceScheduleCarousel ScheduleId={ScheduleId} handleSubmit={handleSubmit} setMaintenanceSchedules={setMaintenanceSchedules} users={mangerUsers} maintenanceSchedules={maintenanceSchedules} contracts={allContracts} />
                </div>
                {/* <div className="carousel-item">
                  <StatusMaintenanceItemsCarousel />
                </div> */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
